/**
 * Service for fetching service uptime data from the backend API
 */

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Fetch service uptime data from the backend
 */
export const getServiceUptimeData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/external-data/service-uptime`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching service uptime data:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Format service uptime data for use in components
 */
export const formatServiceUptimeData = (apiData) => {
  if (!apiData) {
    return null;
  }

  let uptimeValue;
  
  // Check if it's the InsightDB Value Matrix API response format
  if (apiData.responseCode === 200 && apiData.data && Array.isArray(apiData.data) && apiData.data.length > 0) {
    // Get the first item since we expect similar format to other APIs
    const firstItem = apiData.data[0];
    if (firstItem && (
      firstItem.uptime !== undefined ||
      firstItem.service_uptime !== undefined ||
      firstItem.platform_uptime !== undefined ||
      firstItem.availability !== undefined ||
      firstItem.uptime_percentage !== undefined
    )) {
      uptimeValue = firstItem.uptime || 
                    firstItem.service_uptime || 
                    firstItem.platform_uptime || 
                    firstItem.availability || 
                    firstItem.uptime_percentage;
    }
  }
  // Handle fallback API response format
  else if (typeof apiData === 'object') {
    uptimeValue = apiData.uptime || apiData.service_uptime || apiData.platform_uptime;
  } else if (typeof apiData === 'string' || typeof apiData === 'number') {
    uptimeValue = apiData;
  }

  // Ensure we have a valid uptime value
  if (uptimeValue === undefined || uptimeValue === null) {
    return null;
  }

  // Convert to number and format to 2 decimal places
  const numericValue = typeof uptimeValue === 'number' 
    ? uptimeValue 
    : parseFloat(uptimeValue.toString().replace('%', ''));

  // Format to 2 decimal places
  const formattedNumber = numericValue.toFixed(2);
  const formattedUptime = `${formattedNumber}%`;

  return {
    uptime: formattedUptime,
    rawValue: numericValue,
    fallback: false
  };
};